"use client"

import { SunIcon, MoonIcon, Laptop2Icon } from "lucide-react"

import { useTheme } from "@/hooks/use-theme"

export default function ThemeToggle() {
    const { theme, setTheme } = useTheme()

    return (
        <button
            className="px-3 py-2 border border-dashed border-primary/20 rounded-lg hover:bg-primary/10 transition font-mono text-sm"
            onClick={() => setTheme(theme === "auto" ? "dark" : theme === "dark" ? "light" : "auto")}
            aria-label="Toggle theme"
        >
            {theme === "auto" ? (
                <Laptop2Icon className="w-4 h-4" />
            ) : theme === "dark" ? (
                <MoonIcon className="w-4 h-4" />
            ) : (
                <SunIcon className="w-4 h-4" />
            )}
        </button>
    )
}
